import React from 'react';
import '../Post.css';
import Image from './Image'
import PostContent from './PostContent'

function Post(props) {
    return (
        <div className="Post">
            <div className="card">
                <div className="card-image">
                    <Image image={props.image}/>
                </div>
                <div className="card-content">
                    <div className="media">
                        <div className="media-left">
                            <figure className="image is-48x48">
                                <img src="https://bulma.io/images/placeholders/96x96.png" alt="Placeholder" />
                            </figure>
                        </div>
                        <div className="media-content">
                            <div className="title is-4">{props.name}</div>
                            <div className="subtitle is-6">@{props.username}</div>
                        </div>
                    </div>
                    <PostContent content={props.content}/>
                </div>
            </div>
        </div>
    );
}

export default Post;
